import useWebSocket, { ReadyState } from 'react-use-websocket';
import { useDispatch, useSelector } from 'react-redux';
import { updateLoading, updateSocketStatus } from 'store/apps/appConfig';
import { capacityCheck } from 'store/apps/general';
import { accessUserLocker, setLockerCheckout } from 'store/apps/user';
import { useLocation, useNavigate } from 'react-router-dom';
import { fetchUserNotifications } from 'store/apps/notifications';
// import { useRouterTransition } from 'hooks/useRouterTransition';
import { checkoutInfo, updateCheckoutSummaryTime, updateDisableCheckoutButton, updateErrorCheckoutLocker } from 'store/apps/checkout';


export const Socket = ({ showIconStatus }) => {

  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();
  // let { handleTransition } = useRouterTransition(navigate);
  const socket = useSelector(state => state?.appConfig?.socket?.active);
  const numberPrefix = useSelector(state => state?.user?.prefix);
  const number = useSelector(state => state?.user?.number);
  const lockerId = useSelector(state => state.user.activeLockerId);
  const lockerDoor = useSelector(state => state.user.activeLockerDoor);
  const websocketUrl = process.env.REACT_APP_API_WS_URL + '/ws/location-status?access_token=' + process.env.REACT_APP_API_TOKEN;

  const {
    readyState,
  } = useWebSocket(websocketUrl, {
    onOpen: () => changeSocketStatus(true, '::Socket Opened'),
    onClose: () => changeSocketStatus(false, '::Socket Closed'),
    onError: () => changeSocketStatus(false, '::Socket Error'),
    shouldReconnect: () => true,
    reconnectAttempts: Infinity,
    reconnectInterval: () => 1,
    onMessage: (e) => handleTrigger(e)
  })

  const connectionStatus = {
    [ReadyState.CONNECTING]: '::Connecting Socket',
    [ReadyState.OPEN]: '::Socket Opened',
    [ReadyState.CLOSING]: '::Closing Socket',
    [ReadyState.CLOSED]: '::Socket Closed',
    [ReadyState.UNINSTANTIATED]: 'Uninstantiated',
  }[readyState];

  // const navTo = (url, state) => {
  //   if (state) {
  //     handleTransition(url, state)
  //   }
  //   else {
  //     handleTransition(url)
  //   }
  // };

  const changeSocketStatus = (active, status) => {
    dispatch(updateSocketStatus(active))
    console.log(status)
  }

  const fetchLockerData = () => {
    dispatch(
      accessUserLocker({
        numberPrefix: numberPrefix,
        number: number,
        pin: location?.state?.pin,
        locationId: process.env.REACT_APP_LOCATION_ID,
      })
    ).then(() => {
      dispatch(updateLoading(false));
    })
    .catch((error) => {
      dispatch(updateLoading(false))
    });
    
  }

  const handleFetchNotifications = () => {
    dispatch(fetchUserNotifications({ number: number, numberPrefix: numberPrefix }))
  }

  const handleFetchLockerDataRefresh = (e) => {
    if (e?.user?.numberPrefix && e?.user?.phoneNumber) {
      if (numberPrefix.toString() === e?.user?.numberPrefix && number.toString() === e?.user?.phoneNumber) {
        fetchLockerData()
      }
    }
  }

  const handleCheckoutSummary = (e) => {
    if (e?.user?.numberPrefix && e?.user?.phoneNumber) {
      if (numberPrefix.toString() === e?.user?.numberPrefix && number.toString() === e?.user?.phoneNumber) {
        dispatch(updateLoading(true));
        dispatch(checkoutInfo(lockerId))
          .then(() => {
            dispatch(updateLoading(false));
            const date = new Date();
            const options = { timeZone: 'Atlantic/Azores', hour12: false };
            const timeString = date.toLocaleTimeString('default', options);
            const [hour, minute] = timeString.split(':');
            dispatch(updateCheckoutSummaryTime({ hours: hour, minutes: minute }))
          })
          .catch((error) => {
            dispatch(updateLoading(false))
          })
      }
    }
  }

  const handleUpdateCapacity = () => {
    dispatch(capacityCheck(process.env.REACT_APP_LOCATION_ID))
  }

  const openLocker = (e) => {
    if (e?.id === parseInt(lockerId) && e?.doorNumber === parseInt(lockerDoor) && e?.locker_users[0]?.numberPrefix === numberPrefix.toString() && e?.locker_users[0]?.number === number.toString()) {
      dispatch(updateLoading(false));
      dispatch(setLockerCheckout(true))
      dispatch(updateErrorCheckoutLocker(false))
      dispatch(updateDisableCheckoutButton(false))
    }
  }

  const fetchByLocation = (data, message) => {
    if (location?.pathname === "/home") {
      if (message === "UpdateCapacity") {
        handleUpdateCapacity(data);
      }
    }
    else if (location?.pathname === "/access-lockers") {
      if (message === "RefreshLockers") {
        handleFetchLockerDataRefresh(data);
      }
      if (message === "PushNotification") {
        handleFetchNotifications(data);
      }
      if (message === "UpdateTransactions") {
        fetchLockerData(data);
      }
    }
    else if (location?.pathname === "/checkout-summary") {
      if (message === "RefreshLockers") {
        handleCheckoutSummary(data);
      }
    }
    else if (location?.pathname === "/checkout") {
      if (message === "TransactionDoorOpened") {
        openLocker(data)
      }
    }
    else {
      return null
    }
  };

  const handleTrigger = (e) => {
    if (e.data && e.data.charAt(0) === '{') {
      const parsedMsg = JSON.parse(e.data);
      console.log(parsedMsg?.MsgType)
      switch (parsedMsg?.MsgType) {
        case 'RefreshLockers':
          fetchByLocation(parsedMsg?.Data, "RefreshLockers");
          break;
        case 'UpdateCapacity':
          fetchByLocation(parsedMsg?.Data, "UpdateCapacity");
          break;
        case 'TransactionDoorOpened':
          fetchByLocation(parsedMsg?.Data, "TransactionDoorOpened");
          break;
        case 'UpdateTransactions':
          fetchByLocation(parsedMsg?.Data, "UpdateTransactions");
          break;
        case 'PushNotification':
          fetchByLocation(parsedMsg?.Data, "PushNotification")
          break;
        default:
          console.log(`Message type: ${parsedMsg?.MsgType}`);
          console.log(connectionStatus)
          break;
      }
    }
  }

  return (
    showIconStatus &&
    <div
      style={{ height: 30, width: 30, borderRadius: '100%', top: 25, left: 25, position: "absolute" }}
      className={`m-0 p-0 pulse-infinite position-absolute bg-${socket ? "success" : "danger"}`}
    />
  )

};

export default Socket;
